import PropTypes from 'prop-types'
import Svg from 'react-inlinesvg'
import { useSelector } from 'react-redux'

import {
  hasAppliedCodeOrErrorsSelector,
  isCartMinimumErrorSelector,
  isOtherPromoCodeErrorSelector
} from '@/selectors'
import { translate } from '@/utils/translations'

const PromoCodeInfo = ({ isDiscountEligible }) => {
  const hasAppliedCodeOrErrors = useSelector(hasAppliedCodeOrErrorsSelector)
  const isCartMinimumError = useSelector(isCartMinimumErrorSelector)
  const isOtherPromoCodeError = useSelector(isOtherPromoCodeErrorSelector)

  return (
    <If condition={!isDiscountEligible}>
      <If condition={hasAppliedCodeOrErrors}>
        <div className='u-weight--bold'>
          <span className='u-push-quarter--right'>
            <Svg src={require('./images/info-icon.svg')} />
          </span>
          <If condition={isOtherPromoCodeError}>
            {translate('promo_code.notice.item_not_eligible')}
          </If>
          <If condition={isCartMinimumError}>
            {translate('promo_code.notice.cart_min_not_met')}
          </If>
        </div>
      </If>
    </If >

  )
}

PromoCodeInfo.propTypes = {
  isDiscountEligible: PropTypes.bool.isRequired
}

export default PromoCodeInfo
